import React, { useState, useEffect } from 'react';
import ErrorDialog from './ErrorDialog';

export const GlobalErrorDialogContainer = ({ className = '' }) => {
  const [errorDialog, setErrorDialog] = useState(null);

  useEffect(() => {
    const handleShowErrorDialog = (event) => {
      const { title, message, buttonText } = event.detail;
      setErrorDialog({
        title: title || 'Error',
        message: message || 'An error occurred',
        buttonText: buttonText || 'OK'
      });
    };

    window.addEventListener('showErrorDialog', handleShowErrorDialog);
    return () => window.removeEventListener('showErrorDialog', handleShowErrorDialog);
  }, []);

  const handleClose = () => {
    setErrorDialog(null);
  };

  if (!errorDialog) return null;

  return (
    <ErrorDialog
      isOpen={!!errorDialog}
      onClose={handleClose}
      title={errorDialog.title}
      message={errorDialog.message}
      buttonText={errorDialog.buttonText}
    />
  );
};

export default GlobalErrorDialogContainer;

